import React, { useState, useEffect } from 'react';
import './EventSpecial.css';

const EventSpecial = () => {
  const [event, setEvent] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Neuer Ladezustand
  const [isModalOpen, setModalOpen] = useState(false);

  // Fetch event data from the API
  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/events/upcoming`);
        if (response.ok) {
          const data = await response.json();

          // Filter events to find the first upcoming event based on event_date
          const upcomingEvent = data.find(event => new Date(event.event_date) >= new Date());

          // Set the event state if there's an upcoming event
          if (upcomingEvent) {
            setEvent(upcomingEvent);
          }
        } else {
          console.error("Failed to fetch event data");
        }
      } catch (error) {
        console.error("Error fetching event data:", error);
      } finally {
        setIsLoading(false); // Ladezustand beenden
      }
    };
    fetchEvent();
  }, []);

  // Function to handle image click and open modal
  const handleImageClick = () => {
    setModalOpen(true);
  };

  // Function to close modal
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // Ladeanimation oder Fehlermeldung anzeigen
  if (isLoading) {
    return <div className="loading-placeholder">Lädt Event...</div>;
  }

  // Wenn kein Event verfügbar ist, nichts anzeigen
  if (!event) return null;

  return (
    <div className="event-container">
      <div className="stardust-background"></div>
      <div className="event-content">
        <h2 className="event-title">{event.name}</h2>
        <h3 className="event-date">{new Date(event.event_date).toLocaleDateString()}</h3>
        <div className="flyer-container">
          <img
            src={event.image_url}
            alt={event.name}
            className="flyer-image"
            onClick={handleImageClick} // Open modal on click
          />
        </div>
      </div>

      {/* Modal for full-screen view within the viewport */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={event.image_url}
              alt={event.name}
              className="modal-image"
            />
            <button className="modal-close-button" onClick={handleCloseModal}>×</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventSpecial;
